import { Option } from '@/modules/core/domain/interfaces/IFormulary';
import React, { createContext, useContext } from 'react';

export interface FetchDynamicOptionsArgs {
  filterQuestionId: string;
  filterBy: Record<string, string[]>;
}

export interface DynamicOptionsContextData {
  fetchOptions?: (args: FetchDynamicOptionsArgs) => Promise<Option[]>;
}

const DynamicOptionsContext = createContext<DynamicOptionsContextData>({});

export const DynamicOptionsProvider: React.FC<DynamicOptionsContextData> = ({
  fetchOptions,
  children,
}) => {
  return (
    <DynamicOptionsContext.Provider value={{ fetchOptions }}>
      {children}
    </DynamicOptionsContext.Provider>
  );
};

export function useDynamicOptions(): DynamicOptionsContextData {
  return useContext(DynamicOptionsContext);
}
